/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
export interface CheckmarkProps extends React.SVGAttributes<SVGElement> {
size?: string;
}
const Checkmark: React.SFC<CheckmarkProps> = ({size, ...props}) => (
  <svg viewBox="0 0 160 142.222" fill="currentColor" width={ size || "1em" } height={ size || "1em" } {...props}>
    <path d="M0 68.231L18.204 54.496 65.629 105.891 139.88 0 160 11.963 68.024 142.222z" />
  </svg>
);
Checkmark.displayName = 'Checkmark';
export default Checkmark;
/* tslint:enable */
/* eslint-enable */
